"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const VoxeetRTCShim_1 = require("./VoxeetRTCShim");
const loglevel_1 = __importDefault(require("loglevel"));
const bowser_1 = __importDefault(require("bowser"));
const MediaStream_1 = require("../../models/MediaStream");
/**
  VoxeetRTC is the wrapper around plugin or native browser webrtc implementation.
  This will allow us to have the same interface for them, with the help of VoxeetAdapterJs
*/
class VoxeetRTCBase extends events_1.EventEmitter {
    constructor(options = {}) {
        super();
        this.audio3D = options.audio3D;
    }
    addPeer({ peerId, description, candidates, isMaster, state = 'default' }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { peer, isNew } = yield this.createPeerConnection(peerId, state, isMaster);
            yield this.updateMasterStream(peerId, state, isMaster);
            yield this.setRemoteDescription(peerId, this.getSsrc(description.sdp), description.type, description.sdp);
            isNew && !VoxeetRTCShim_1.isNode && peer && peer.isMaster && (yield this.addMasterStream(peer));
            yield Promise.all(candidates.map((c) => __awaiter(this, void 0, void 0, function* () {
                if (!bowser_1.default.msedge) {
                    yield this.setPeerCandidate(peerId, c.mid, c.mline_index, c.sdp);
                }
            })));
            yield this.createAnswer(peerId, state, description.oid); // No need to wait for ice candidates gathering
        });
    }
    setRemoteSdp(peerId, description, candidates, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.setRemoteDescription(peerId, this.getSsrc(description.sdp), description.type, description.sdp, callback);
        });
    }
    removePeer(peerId) {
        this.closePeerConnection(peerId).catch((e) => console.warn('Peer connection close error', e.message));
        this.removePeerConnection(peerId);
    }
    getSsrc(sdp) {
        var regexp = /a=ssrc\:(.*?)\s/gm;
        var matches = regexp.exec(sdp);
        loglevel_1.default.trace('VoxeetRTC.getSsrc', matches);
        return matches && matches[1] != null ? matches[1] : '0';
    }
    checkStream(stream) {
        // Checking stream type and returning peerId
        const re = /([0-9]*)_?([a-zA-Z0-9]*)_?([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})/gm;
        //const re = /([a-zA-Z0-9]*)_([0-9A-F]*)/gm;
        let matches = re.exec(stream.id);
        //TODO: what if matches = [] ?
        if (matches[1] == MediaStream_1.MediaStreamIndex.Camera) {
            stream.type = MediaStream_1.MediaStreamType.Camera;
        }
        else if (matches[1] == MediaStream_1.MediaStreamIndex.ScreenShare) {
            stream.type = MediaStream_1.MediaStreamType.ScreenShare;
        }
        else if (matches[1] >= MediaStream_1.MediaStreamIndex.Custom) {
            stream.label = matches[2];
            stream.type = MediaStream_1.MediaStreamType.Custom;
        }
        else {
            stream.type = MediaStream_1.MediaStreamType.Camera;
        }
        return matches[3];
    }
    updateMasterStream(peerId, type, isMaster) {
        return Promise.resolve();
    }
    sessionCreatedEvent(peerId, sessionDescription, candidates, ssMsid, state, oid, wasm) {
        loglevel_1.default.trace('VoxeetRTC.onSessionCreated', peerId, sessionDescription, candidates, wasm);
        this.emit('sessionCreated', peerId, sessionDescription, candidates, ssMsid, state, oid, wasm);
    }
    // stream can be null when using plugin
    addStreamEvent(peerId, stream) {
        loglevel_1.default.trace('VoxeetRTC.addStream', peerId, stream);
        this.emit('addStream', peerId, stream);
    }
    updateStreamEvent(peerId, stream) {
        loglevel_1.default.trace('VoxeetRTC.updateStream', peerId, stream);
        this.emit('updateStream', peerId, stream);
    }
    removeStreamEvent(peerId) {
        loglevel_1.default.trace('VoxeetRTC.removeStream', peerId);
        this.emit('removeStream', peerId);
    }
    addScreenStreamEvent(peerId, stream) {
        loglevel_1.default.trace('VoxeetRTC.addScreenStream', peerId, stream);
        this.emit('addScreenStream', peerId, stream);
    }
    removeScreenStreamEvent(peerId, stream) {
        loglevel_1.default.trace('VoxeetRTC.removeScreenStream');
        this.emit('removeScreenStream', peerId, stream);
    }
    endedScreenStreamEvent() {
        this.emit('endedScreenStream');
    }
    updateScreenStreamEvent(peerId, stream) {
        this.emit('updateScreenStream', peerId, stream);
    }
    iceCandidatesGatheringCompleteEvent(peerId, candidates) {
        this.emit('iceCandidatesGatheringComplete', peerId, candidates);
    }
    connectionStatusEvent(status) {
        this.emit('connectionStatus', status);
    }
    initializeCallstats(ownerId, conferenceId) {
        return Promise.resolve();
    }
    // Connections
    init({ constraints, processCb, listenOnly, ownerId, options }) {
        loglevel_1.default.error('abstract implementation init');
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            loglevel_1.default.error('abstract implementation release');
        });
    }
    createPeerConnection(peerId, state, isMaster) {
        loglevel_1.default.error('abstract implementation createPeerConnection');
    }
    closePeerConnection(peerId) {
        loglevel_1.default.error('abstract implementation closePeerConnection');
    }
    removePeerConnection(peerId) {
        loglevel_1.default.error('abstract implementation removePeerConnection');
    }
    createAnswer(peerId, state = 'default', oid) {
        loglevel_1.default.error('abstract implementation createAnswer');
    }
    setRemoteDescription(peerId, ssrc, type, sdp, cb) {
        loglevel_1.default.error('abstract implementation setRemoteDescription');
    }
    setPeerCandidate(peerId, sdpMid, sdpMLineIndex, sdp) {
        loglevel_1.default.error('abstract implementation setPeerCandidate');
    }
    toggleMute(peerId) {
        loglevel_1.default.error('abstract implementation');
    }
    toggleOwnMute() {
        loglevel_1.default.error('abstract implementation');
    }
    mutePeer(peerId, isMuted) {
        loglevel_1.default.error('abstract implementation');
    }
    //Control
    getLevel(peerId, callback) {
        loglevel_1.default.error('abstract implementation');
    }
    isSpeaking(peerId, callback) {
        loglevel_1.default.error('abstract implementation');
    }
    // x = [-1, 1], y = [0, 1]
    setPeerPosition(peerId, posX, posY) {
        loglevel_1.default.error('abstract implementation setPeerPosition');
    }
    getPeerPosition(peerId) {
        loglevel_1.default.error('abstract implementation getPeerPosition');
    }
    setGain(peerId, gain) {
        loglevel_1.default.error('abstract implementation');
    }
    startVideoForPeer(peerId, constraints) {
        loglevel_1.default.error('abstract implementation');
    }
    stopVideoForPeer(peerId) {
        loglevel_1.default.error('abstract implementation');
    }
    // Screensharing
    startScreenShare(sourceId, cb) {
        loglevel_1.default.error('abstract implementation');
    }
    stopScreenShare() {
        loglevel_1.default.error('abstract implementation');
    }
    changeRecordingDevice() {
        loglevel_1.default.error('abstract implementation');
    }
    // Devices management
    selectAudioInput(deviceId) {
        loglevel_1.default.error('abstract implementation');
    }
    selectVideoInput(deviceId) {
        loglevel_1.default.error('abstract implementation');
    }
    selectAudioOutput(deviceId) {
        loglevel_1.default.error('abstract implementation');
    }
    getInboundRtpStats() {
        loglevel_1.default.warn('Abstract getInboundRtpStats');
        return Promise.resolve();
    }
    configureStateDump(audioLoggingLength = 60) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    getStateDumpConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(0);
        });
    }
    createStateDump(liteMode) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    setTransparentMode(transparent) {
        return __awaiter(this, void 0, void 0, function* () {
            loglevel_1.default.error('abstract implementation setTransparentMode');
        });
    }
    setComfortNoiseLevel(level) {
        loglevel_1.default.error('abstract implementation setComfortNoiseLevel');
    }
    getComfortNoiseLevel() {
        loglevel_1.default.error('abstract implementation getComfortNoiseLevel');
    }
}
exports.default = VoxeetRTCBase;
